const DPI = 72; // 72pt per inch.
const CM_FACTOR = (1 / 2.54) * DPI;

const SMALLCAP_WORD_COUNT = 4;

const VERY_VERY_SMALL_MARGIN = "1pt";
const VERY_SMALL_MARGIN = "5pt";
const SMALL_MARGIN = "10pt";
const MEDIUM_MARGIN = "20pt";
const BLOCKQUOTE_MARGIN = "30pt";
const CODE_BLOCK_MARGIN = "80pt";

const ADDITIONAL_FONT_SIZE_TO_ORNAMENTAL_BREAK = 4;
const ADDITIONAL_FONT_SIZE_MULTIPLIER_TO_DROPCAP = 2.5;

const SPACE_BETWEEN_FOOTER_AND_BODY = 10; // pt
const HEADER_MIN_HEIGHT = 30; // [pt] min - 28 (for all base fonts [max size 18pt])
const ADDITIONAL_FOOTER_HEIGHT = 7; // pt

const ORNAMENTALBREAK_MARGIN_TOP = 20;
const ORNAMENTALBREAK_MARGIN_BOTTOM = 20;

const ADDITIONAL_CHAPTER_MARGINS = {
    top: 0.3,
    bottom: 0.2
};

export {
    SMALLCAP_WORD_COUNT,
    VERY_VERY_SMALL_MARGIN,
    VERY_SMALL_MARGIN,
    SMALL_MARGIN,
    MEDIUM_MARGIN,
    BLOCKQUOTE_MARGIN,
    CODE_BLOCK_MARGIN,
    ADDITIONAL_FONT_SIZE_TO_ORNAMENTAL_BREAK,
    ADDITIONAL_FONT_SIZE_MULTIPLIER_TO_DROPCAP,
    SPACE_BETWEEN_FOOTER_AND_BODY,
    HEADER_MIN_HEIGHT,
    ADDITIONAL_FOOTER_HEIGHT,
    ORNAMENTALBREAK_MARGIN_TOP,
    ORNAMENTALBREAK_MARGIN_BOTTOM,
    CM_FACTOR,
    ADDITIONAL_CHAPTER_MARGINS
};